import { useContextState } from "../../../../../../hooks/theme"

const useUnitStyles = () => {
    const { colors } = useContextState()
    return {
        containerUnit: {
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: '180px'
        },
        unitTitle: {
            fontSize: '14px',
            fontWeight: '600',
            color: colors.color9,
            overflow: 'hidden',
            whiteSpace: 'normal',
        },
        unitContent: {
            fontSize: '12px',
            color: colors.color10,
            width: '100%',
        },
        user: {
            fontSize: '12px',
            color: colors.color10,
            width: '100%',
        },
    }
}

export { useUnitStyles }